export default __webpack_public_path__ + "static/media/whiteTbaIcon.220edaf7.svg";